import agentWarning from "~/images/agentWarning.svg";
import { createFragmentContainer, graphql } from "react-relay";

type Props = {
  agent: any;
};

function AgentUpgradeBanner({ agent }: Props) {
  if (!agent.version) {
    return null;
  }

  return (
    <section
      className="very-dark-gray border-gray mb-2 rounded-sm border"
      style={{ borderLeft: "3px solid #fbca44" }}
    >
      <div className="m-2">
        <h4 className="semi-bold m-0 mb-1 p-0 text-sm">
          <img src={agentWarning} className="mr-1 inline" />
          <span>Agent Upgrade Required</span>
        </h4>
        <p className="dark-gray">
          buildkite-agent {agent.version} has known issues and should be upgraded to a later
          version. See the{" "}
          <a
            href={`https://github.com/buildkite/agent/releases/tag/v${agent.version}`}
            className="lime hover-underline no-underline"
          >
            release notes on GitHub
          </a>{" "}
          for more information.
        </p>
      </div>
    </section>
  );
}

export default createFragmentContainer(AgentUpgradeBanner, {
  agent: graphql`
    fragment AgentUpgradeBanner_agent on Agent {
      ... on Agent {
        version
      }
    }
  `,
});
